(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["marquee"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialized = new WeakSet();

    function buildMarquee(scope) {
      const root = scope instanceof Element ? scope : document;
      const marquees = root.querySelectorAll('[data-marquee]');

      marquees.forEach((marquee) => {
        if (initialized.has(marquee)) {
          return;
        }

        const track = marquee.querySelector('[data-marquee-track]');
        const sourceSet = marquee.querySelector('[data-marquee-set]');

        if (!track || !sourceSet) {
          return;
        }

        initialized.add(marquee);

        const sync = () => {
          track.querySelectorAll('[data-marquee-clone="true"]').forEach((clone) => clone.remove());

          const sourceWidth = sourceSet.offsetWidth;
          const viewportWidth = marquee.offsetWidth;

          if (!sourceWidth || !viewportWidth) {
            return;
          }

          marquee.style.setProperty('--marquee-distance', `${sourceWidth}px`);

          let totalWidth = track.scrollWidth;
          let attempts = 0;

          while (totalWidth < viewportWidth + sourceWidth && attempts < 12) {
            const clone = sourceSet.cloneNode(true);
            clone.setAttribute('aria-hidden', 'true');
            clone.setAttribute('data-marquee-clone', 'true');
            track.appendChild(clone);
            totalWidth = track.scrollWidth;
            attempts += 1;
          }
        };

        sync();

        if ('ResizeObserver' in window) {
          const resizeObserver = new ResizeObserver(sync);
          resizeObserver.observe(marquee);
          resizeObserver.observe(sourceSet);
        } else {
          window.addEventListener('resize', sync);
        }

        window.addEventListener('load', sync, { once: true });
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => buildMarquee(document));
    } else {
      buildMarquee(document);
    }

    document.addEventListener('shopify:section:load', (event) => buildMarquee(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
